package top.wcpe.allincore.ui.runtime.render

import top.wcpe.allincore.layout.engine.Box
import top.wcpe.allincore.ui.runtime.element.Divider
import top.wcpe.allincore.ui.runtime.element.UIElement
import top.wcpe.allincore.ui.runtime.render.UiRenderBridge

/**
 * 分隔线渲染器：M2 简化实现为水平细矩形，高度取 [Divider.thickness]。
 */
class DividerRenderer : Renderer {

    override fun render(element: UIElement<*>, box: Box, bridge: UiRenderBridge) {
        val d = element as Divider
        val thickness = if (d.thickness() > 0) {
            d.thickness()
        } else {
            maxOf(1f, minOf(box.width(), box.height()))
        }
        bridge.fillRect(box.x(), box.y(), box.width(), thickness, d.color())
    }
}
